import React from 'react';
import { StaticNav } from '@tkww/the-bash-frontend';
import { gmConfig } from 'helpers/config';

const StaticHeader = () => <StaticNav wwwDomain={gmConfig.domains.www} />;

export default StaticHeader;
